export default __webpack_public_path__ + "static/media/ic_city_b.d06e371b.svg";